import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  btnControl: {
    margin: theme.spacing(1),
    float: "right",
  },
  queueSectionTitle: {
    padding: "0px !important",
    textAlign: "left",
    letterSpacing: "normal",
  },
  fortmatFieldLabel: {
    textAlign: "left",
    letterSpacing: "normal",
    fontSize: "11px",
  },
  formatSelectBox: {
    width: "98%",
    height: "30px",
    fontSize: "11px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
}));
